module.exports = __webpack_public_path__ + "static/img/knowledgHome.b33f5011.png";